import { render, staticRenderFns } from "./multiselectTag.vue?vue&type=template&id=7815b09f"
import script from "./multiselectTag.vue?vue&type=script&lang=js"
export * from "./multiselectTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports